/**
 * Mirrors the Prisma `DesignProjectOrigin` enum so the legacy-onboarding routing
 * gate and the frontends can branch on provenance without importing Prisma
 * types. Keep in sync with prisma/schema.prisma.
 */
export enum DesignProjectOrigin {
  NATIVE = "NATIVE",
  LEGACY_FIRESTORE_MIGRATION = "LEGACY_FIRESTORE_MIGRATION",
}
